// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePoolJoinPreviewBody = {
  code?: string;
  joinCode?: string;
  targetPoolId?: string;
};

export type typePoolJoinPreviewOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    outcome: "grant" | "reference";
    pool: {
      poolId: string;
      poolRefId?: string | null;
      name: string;
      sportKey: string;
      leagueKey: string;
      seasonYear: number;
      contestType: "survivor" | "squares" | "stripCard" | "pickem";
      joinPolicy: "open" | "approval";
      visibility: "public" | "private";
      autoApprove: boolean;
      activeMemberCount: number;
      isFull: boolean;
      maxMembers: number | null;
    };
    rulesSummary: string;
    isAlreadyMember: boolean;
    membershipStatus?:
      | "pending"
      | "active"
      | "suspended"
      | "left"
      | "removed"
      | "rejected"
      | null;
    invitedByName?: string | null;
    commissionerName?: string;
  };
};

export type typePoolJoinPreviewOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolJoinPreviewOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolJoinPreviewOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPoolJoinPreviewBody = {
  type: "object",
  properties: {
    code: { type: "string", maxLength: 3000, minLength: 1 },
    joinCode: { type: "string", maxLength: 3000, minLength: 1 },
    targetPoolId: { type: "string", maxLength: 3000, minLength: 1 },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPoolJoinPreview(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPoolJoinPreviewBody);
  }

  return async function postPoolJoinPreview(
    payload: typePoolJoinPreviewBody,
  ): Promise<typePoolJoinPreviewOutput200 | typePoolJoinPreviewOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPoolJoinPreview" failed before calling the network. #40e01162d1f6`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#40e01162d1f6" },
        },
        data: null,
      } as typePoolJoinPreviewOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pool/join-preview`,
      httpMethod: "POST",
      options,
    })) as typePoolJoinPreviewOutput200 | typePoolJoinPreviewOutput400;
  };
}
